import { Injectable } from '@angular/core';
import { Store, StoreConfig } from '@datorama/akita';
import { WorkCenterCounter } from 'chronos-core-client';

function createInitialState(): Partial<WorkCenterCounter> {
  return {
    counter: null,
    speed: null,
  };
}

@Injectable({ providedIn: 'root' })
@StoreConfig({ name: 'machine-counter' })
export class MachineCounterStore extends Store<WorkCenterCounter> {
  constructor() {
    super(createInitialState());
  }
}
